<script setup lang="ts">
import IconThermometer from '~icons/mdi/thermometer'
import IconSnowflakeThermometer from '~icons/mdi/snowflake-thermometer'

interface Props {
  temperatureType?: 'AMBIENT' | 'CHILLED' | 'FREEZ' | null
}

const props = withDefaults(defineProps<Props>(), {})
</script>

<template>
  <v-tooltip v-if="props.temperatureType === 'CHILLED'" :text="$t('tooltip.productChilled')">
    <template #activator="{ props: tooltipProps }">
      <v-avatar
        v-bind="tooltipProps"
        size="28"
        color="grey-lighten-3"
        class="my-1 text-blue"
        data-test-id="temperature-icon-chilled"
      >
        <v-icon :icon="IconThermometer" size="18" />
      </v-avatar>
    </template>
  </v-tooltip>
  <v-tooltip v-else-if="props.temperatureType === 'FREEZ'" :text="$t('tooltip.productFrozen')">
    <template #activator="{ props: tooltipProps }">
      <v-avatar
        v-bind="tooltipProps"
        size="28"
        color="blue-lighten-3"
        class="mt-1"
        data-test-id="temperature-icon-frozen"
      >
        <v-icon :icon="IconSnowflakeThermometer" size="18" />
      </v-avatar>
    </template>
  </v-tooltip>
</template>
